import * as React from "react";
import { Link } from "gatsby";

// course-wrapper block group/tile rounded border-2 border-felt-200 bg-felt-900
// rounded-t aspect-video bg-cover block w-100 transition-all duration-100 opacity-75 group-hover/tile:opacity-100 contrast-150 group-hover/tile:contrast-100 saturate-150 group-hover/tile:saturate-100

const ShowStream = (props) => {
  const { video, game } = props;

  const isVideoString = typeof video === "string";
  const ytId = isVideoString ? video : video.yt;
  const youTubeShortLink = `https://youtu.be/${ytId}`;

  const link = isVideoString
    ? youTubeShortLink
    : video.post
    ? video.post
    : youTubeShortLink;
  const thumbnail = `https://img.youtube.com/vi/${ytId}/hqdefault.jpg`;

  const imageStyles =
    "rounded-t bg-cover block transition-all duration-100 saturate-0 group-hover/tile:saturate-100";

  return (
    <div key={ytId}>
      <LinkVideo link={link}>
        <img
          src={thumbnail}
          alt={`YouTube ${ytId} for ${game}`}
          className={`w-full h-auto rounded ${imageStyles}`}
        />
      </LinkVideo>
    </div>
  );
};

const LinkVideo = (props) => {
  const linkWrapper =
    "course-wrapper block group/tile rounded border-2 border-felt-200 bg-felt-900";

  if (props.link.includes("https")) {
    return (
      <a
        key={`${props.link}`}
        href={props.link}
        target="_blank"
        rel="noreferrer"
        className={linkWrapper}
      >
        {props.children}
      </a>
    );
  }
  return (
    <Link to={props.link} className={linkWrapper}>
      {props.children}
    </Link>
  );
};

export { ShowStream };
